import dundrumImage from "../images/130-Sandyford-Road_DSC1374_Panorama-5 1-about.jpg";
import KillakeeImage from "../images/Aragon-Killakee_DSC9413_Panorama 2-about.jpg";

const testimonials = [
  {
    id: 1,
    image: dundrumImage,
    name: "Dundrum Client",
    text: [
      "Emmet has created a comfortable, light filled and functioning family home for us which we love living in.",
      " We were continually impressed by your attention to detail, professionalism, care and support provided throughout the project.",
      "You made the process easier for us and your ability to explain ideas and also the impact of decisions was invaluable.",
      "Emmet took the time to support wider decisions on the build and fit-out which greatly enhanced the finish.",
      "You worked well with the wider project team which is key to delivery.",
      "We would highly recommend Emmet to anyone",
    ],
  },
  {
    id: 2,
    image: KillakeeImage,
    name: "Killakee Client",
    text: [
      "We engaged the services of Emmet Power to design a kitchen/dining room extension.",
      "He produced several drawings based on our and his vision of the final build, reflecting current building regulations, materials, and finish. Once the final design was agreed, Emmet engaged directly with the local planning authority and having successfully secured planning permission, a contractor was identified and a price agreed.",
      "Emmet managed the project from beginning to end and ensured building and contract compliance.",
      "We regard ourselves as very lucky to have engaged the services of Emmet who was a true professional, had an eye for detail, ability to listen and communicate so well with both us and the Building Contractor.",
      "We ended up with an extension which is light-filled, spacious, enhances our views, and enriches our time spent in this additional part of our house.",
      "We love it and would highly recommend Emmet.",
    ],
  },
];

export { testimonials };
